// extracted by mini-css-extract-plugin
export default {"IconButton":"CustomIconButton_IconButton__tovnI","IconButtonPrimary":"CustomIconButton_IconButtonPrimary__kCAp3"};